export const SIGNALR_MESSAGE_TYPES = {
  NOTIFICATION: "Notification",
  NAS_TRANSACTIONS_CHECKINS: "NAS_TRANSACTIONS_CHECKINS",
  NAS_TRANSACTIONS_ADD_CLINIC_QUE: "NAS_TRANSACTIONS_ADD_CLINIC_QUE",
  NAS_TRANSACTIONS_REMOVE_CLINIC_QUE: "NAS_TRANSACTIONS_REMOVE_CLINIC_QUE",
  NAS_TRANSACTIONS_ADD_GUIDANCE_QUE: "NAS_TRANSACTIONS_ADD_GUIDANCE_QUE",
  NAS_TRANSACTIONS_REMOVE_GUIDANCE_QUE: "NAS_TRANSACTIONS_REMOVE_GUIDANCE_QUE",
  CORE_SECURITY_AUDITLOGS: "CORE_SECURITY_AUDITLOGS",
  CORE_LOGIN: "CORE_LOGIN",
};
